import { useEffect } from "react";

export default function Seo({ title, description, noindex }) {
  useEffect(() => {
    if (title) document.title = title;
    const set = (name, content) => {
      let m = document.querySelector(`meta[name="${name}"]`);
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", name);
        document.head.appendChild(m);
      }
      m.setAttribute("content", content);
    };
    if (description) set("description", description);
    if (noindex) set("robots", "noindex, nofollow");
  }, [title, description, noindex]);
  return null;
}
